export const classes = {
  wrapper: 'text-[13px] leading-tight text-taupe-2 dark:text-mauve-2',
};
